// extracted by mini-css-extract-plugin
export default {"card":"DataHubCard_card__YUh18"};